import { render, staticRenderFns } from "./VRoot.vue?vue&type=template&id=4f3823b4&"
import script from "./VRoot.vue?vue&type=script&lang=js&"
export * from "./VRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports